import { NgModule } from '@angular/core';
import { YyyymmddPipe } from './date/yyyymmdd';
import { HhiiPipe } from './date/hhii';
import { HhiissPipe } from './date/hhiiss';

import { YmdPipe } from './date/ymd';
import { YyyymmPipe } from './date/yyyymm';


import { ToFixedPipe } from './number-format/to-fixed';
import { HtmlSafePipe } from './html-safe';
import { DateFormatPipe } from './date/date-format';
import { TimestampFormatPipe } from './date/timestamp-format';


@NgModule({
	declarations: [HtmlSafePipe, YyyymmddPipe, YmdPipe, YyyymmPipe, HhiiPipe, HhiissPipe, ToFixedPipe,
    DateFormatPipe, TimestampFormatPipe],
	imports: [],
	exports: [HtmlSafePipe, YyyymmddPipe, YmdPipe, YyyymmPipe, HhiiPipe, HhiissPipe, ToFixedPipe,
    DateFormatPipe, TimestampFormatPipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts